import React from 'react';
import PageFrame from 'components/common/PageFrame';
import InformatizationOfNDTab from 'components/menu/business/InformatizationOfNDTab';
import ElectronicWarfareTab from 'components/menu/business/ElectronicWarfareTab.js';
import SystemIntegrationTab from 'components/menu/business/SystemIntegrationTab.js';
import menuItems from 'assets/data/menuItems.json';

const showTab = (id) => {
    switch (id) {
        case 0:
            return <InformatizationOfNDTab />
        case 1:
            return <ElectronicWarfareTab />
        case 2:
            return <SystemIntegrationTab />
        default: return;
    }
}

const BusinessPage = () => {

    return (
        <section className='BusinessPage'>
            <PageFrame subMenuItems={menuItems[1].tabs} showTab={showTab} rest={50} page={'business'} />
        </section>
    );
};

export default BusinessPage;